/**
 * Курсор следующей страницы для `getNextPageParam`.
 *
 * ⚠️ КОНЕЦ СПИСКА — ПУСТОЙ **ИЛИ** ОТСУТСТВУЮЩИЙ КУРСОР. Нормативно это сказано в общей шапке про
 * курсоры (`components/schemas/common.yaml`); схемы гостей, переписок, разбора входящих и задач
 * повторяют это у себя, у броней и событий каналов описания нет вовсе — тем важнее одно место.
 *
 * А `lastPage.nextCursor ?? undefined` ловит только второе: пустая строка проходит насквозь, движок
 * считает следующую страницу существующей (`!= null`), и «показать ещё» бесконечно тянет ПЕРВУЮ
 * страницу с `cursor=` — те же строки, те же React-ключи.
 *
 * Отсюда общий помощник, а не `||` по месту: правило одно на шесть курсорных списков, и написанное
 * шестью руками оно уже разъехалось — ПЯТЬ из шести стояли через `??`, верно был написан только
 * список гостей. (Ту же проверку по-своему выражает `entities/conversation/model/triage.ts` —
 * `Boolean(nextCursor)`; там она корректна, но это седьмое написание того же правила.)
 *
 * Почему это не паранойя: шлюз на Go, и он сам назвал нам это причиной прошлой аварии — строковое
 * поле без `omitempty` уезжает как `""`, с ним пропадает совсем (`docs/letters/2026-08-08-catalog-
 * empty-arrays.md`, там же про nil-слайсы). Обе формы конца списка приходят от одного шлюза в
 * зависимости от того, как объявлено поле, и рассчитывать на одну из них нельзя.
 */
export function nextCursorParam(cursor: string | null | undefined): string | undefined {
  return cursor ? cursor : undefined
}
